import axios from 'axios';

class PortfolioService {
    listarCapas = () => {
        return axios.get(process.env.PUBLIC_URL + "/img/projetos/projetos.json")
    }
}

export default new PortfolioService();